import { IconButton, InputAdornment, Tooltip } from "@material-ui/core";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import RefreshIcon from "@material-ui/icons/Refresh";
import { MouseEventHandler } from "react";
import useClipboard from "utils/useClipboard";

interface Props {
  value: string;
  onGenerate?: MouseEventHandler<HTMLButtonElement>;
  generateTooltip?: string;
  copyTooltip?: string;
}

export default function FieldActions(props: Props) {
  const { onGenerate, value } = props;
  const copyToClipboard = useClipboard();

  return (
    <InputAdornment position="end" style={{ gap: "5px", marginRight: "5px" }}>
      <Tooltip title={props.copyTooltip}>
        <IconButton
          onClick={() => copyToClipboard(value)}
          edge="end"
          disabled={!value}
        >
          <FileCopyIcon />
        </IconButton>
      </Tooltip>
      {onGenerate && (
        <Tooltip title={props.generateTooltip}>
          <IconButton onClick={onGenerate} edge="end">
            <RefreshIcon />
          </IconButton>
        </Tooltip>
      )}
    </InputAdornment>
  );
}
